import { ready } from '@/lib/ready'
import { on } from '@/lib/dom/on'
import { hasClass } from '@/lib/dom/hasClass'
import { getIndex } from '@/lib/dom/getIndex'

// product-video
ready(() => {
  // loadJs('https://www.youtube.com/iframe_api')
  const videoEls = document.querySelectorAll('.video-icon') as NodeListOf<HTMLElement>
  videoEls.forEach((el: HTMLElement) => {
    on(el, 'click', () => {
      const videoUrl = el.dataset['videoUrl']
      const videoThumb = el.dataset['videoThumb']
      if (videoUrl) {
        // loading.show();
        import('@/share/play-video').then((f) => {
          const { playVideo, closeVideo } = f.usePlayVideo(800, 495)
          playVideo({
            videoUrl: videoUrl,
            thumbnail: videoThumb,
            reloadVideo: true
          })
        })
      }
    })
  })
})

ready(() => {
  const hdShoppingCartList = document.querySelector<HTMLInputElement>('#hdShoppingCartList')
  if (hdShoppingCartList && hdShoppingCartList.value.length > 0) {
    // const overlay = '<a class="mask-layer" href="@link"><span class="mask-layer-tips">Item In Cart<i></i></span></a>';
    const arr = hdShoppingCartList.value.split(',')
    if (arr.length > 0) {
      for (let i = 0; i < arr.length; i++) {
        const productItem = document.querySelector('#ProductGrid_' + arr[i])
        if (productItem) {
          // var link = $('#imgBig' + arr[i]).prop('href');
          const link = document.getElementById('imgBig' + arr[i])!.getAttribute('href')!
          productItem
            .parentElement!.querySelector('.onsale_img, .product-img')!
            .insertAdjacentHTML(
              'beforeend',
              `<a class="mask-layer" href="${link}"><span class="mask-layer-tips">Item In Cart<i></i></span></a>`
            )
          // $('#ProductGrid_' + arr[i]).parent().append(overlay.replace('@link', link));
        }
        // if ($('#ProductGrid_' + arr[i]).length > 0) {
        //   var link = $('#imgBig' + arr[i]).prop('href');
        //   $('#ProductGrid_' + arr[i]).parent().append(overlay.replace('@link', link));
        // }
      }
    }
  }
})

ready(() => {
  document.querySelectorAll('.OOS-grey').forEach((element) => {
    const layer = element.querySelector('.mask-layer') as HTMLElement | null

    if (!layer) {
      // Find the link within '.onsale_img a' that does not have the 'video-icon' class
      const linkElement = element.querySelector(
        '.onsale_img a:not(.video-icon)'
      ) as HTMLAnchorElement | null
      const link = linkElement ? linkElement.href : '#'

      // Insert the overlay HTML with the dynamic link
      element
        .querySelector('.onsale_img, .product-img')!
        .insertAdjacentHTML(
          'beforeend',
          `<a class="mask-layer" href="${link}"><img src="https://img66.anypromo.com/frontimg/2020/icon/ico-stock-1.svg" class="ico-outstock" /></a>`
        )
    } else {
      // Insert the out-of-stock icon at the beginning of the existing layer
      layer.insertAdjacentHTML(
        'afterbegin',
        `<img src="https://img66.anypromo.com/frontimg/2020/icon/ico-stock-1.svg" class="ico-outstock" />`
      )
    }
  })
})

ready(() => {
  on(document, 'click', '.onsale_img a,.onsale_name a,.mask-layer', (event: MouseEvent) => {
    const target = event.target as HTMLElement

    const content = target.closest('.onsale-content')!
    let pid = ''
    if (hasClass(content, 'slickdeals'))
      pid = content.getAttribute('id')!.replace('ProductGrid_', '')
    else pid = content.querySelector('.onsale_id')!.innerHTML.replace('#', '')

    window.dataLayer.push({ ecommerce: null }) // Clear the previous ecommerce object.
    window.dataLayer.push({
      event: 'select_item',
      ecommerce: {
        items: [
          {
            item_id: pid,
            item_name: content.querySelector('.onsale_name a')?.textContent,
            currency: 'USD',
            index: getIndex(content, document.querySelectorAll('.onsale-content')) + 1
          }
        ]
      }
    })
  })
})
